export const editDriverDialogData = (details) =>[
  {
    placeholder: 'Name',
    required: false,
    type: 'text',
    name: 'vendorName',
    label: 'Driver Name',
    countrycode: false,
    defaultValue: details?.name || '',
  },
  {
    placeholder: 'Mobile Number',
    required: false,
    type: 'text',
    name: 'number',
    label: 'Mobile Number',
    countrycode: true,
    defaultValue:details?.mobile?.replaceAll("+91","") || '',
  },
  {
    placeholder: 'Email',
    required: false,
    type: 'text',
    name: 'email',
    label: 'Email',
    countrycode: false,
    defaultValue:details?.email || '',
  }
];